/*
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-03-02 11:50:32
 * @LastEditTime: 2022-04-15 14:11:36
 * @Description:
 */
const OPERATION_TYPE_DATA = [
  {
    key: "Check",
    value: 0,
    text: "比对未完成"
  },
  {
    key: "Same",
    value: 1,
    text: "比对一致"
  },
  {
    key: "Create",
    value: 2,
    text: "创建"
  },
  {
    key: "Update",
    value: 3,
    text: "修改"
  },
  {
    key: "Disable",
    value: 10,
    text: "禁用"
  },
  {
    key: "Delete",
    value: 20,
    text: "标记删除"
  },
  {
    key: "Remove",
    value: 30,
    text: "删除"
  },
  {
    key: "MoveToDefault",
    value: 40,
    text: "移动到默认部门"
  },
  /*  {
    key: "Archive",
    value: 100,
    text: "邮件归档设置"
  }, */
  {
    key: "RsLimit",
    value: 200,
    text: "收发权限设置"
  },
  {
    key: "Ignore",
    value: 1000,
    text: "忽略"
  },
  {
    key: "Clean",
    value: 10000,
    text: "无效节点记录清理"
  },
  {
    key: "Protect",
    value: 100000,
    text: "保护"
  }
];
const OPERATION_TYPE = {};
const OPERATION_TYPE_TEXT = {};
for (let item of OPERATION_TYPE_DATA) {
  OPERATION_TYPE[item.key] = item.value;
  OPERATION_TYPE_TEXT[item.value] = item.text;
}
export { OPERATION_TYPE, OPERATION_TYPE_TEXT };
